<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import {
  useSelectSource,
} from '../../../../model/additional-info/success/info-success-bad-feedback/select-source.hook'

defineOptions({
  name: 'SelectSource',
})

const {
  placeholder,
  model,
  options,
} = useSelectSource()
</script>

<template>
  <AppSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
  />
</template>
